import styled from 'styled-components'
import { Box, IconButton, TableCell, TextField, Typography, ListItem } from '@material-ui/core'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { ReactComponent as DeleteIcon } from 'icons/trash-icon.svg'
import { Delete, ExpandLess, ExpandMore, Home, Event, Store } from '@material-ui/icons'
import { ReactComponent as FilterIcon } from 'icons/filter-icon-search.svg'
import { Button } from 'common/atoms/Button/Button'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 360
    },
    nested: {
      paddingLeft: theme.spacing(10)
    }
  })
)

export const StyledHomeButton = styled(Home)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledEventButton = styled(Event)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledProductButton = styled(Store)`
  && {
    font-size: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledListItem = styled(ListItem) <{ active: number; index: number }>`
  && {
    background-color: ${props => (props.active === props.index ? props.theme.colors.primary : null)};
    color: ${props => (props.active === props.index ? props.theme.colors.accent1: null)};

    :hover {
      background-color: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.accent};
    }
  }
`

export const StyledFilterIcon = styled(FilterIcon)`
  && {
    transform: scale(0.75);
    fill: ${props => props.theme.colors.primary};
  }
`
export const StyledDeleteIcon = styled(DeleteIcon)`
  && {
    fill: ${props => props.theme.colors.error};
    width: 0.8em;
    height: 0.8em;
    margin-right: 1em;
    cursor: pointer;
  }
`

export const StyledHeadTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
  }
`
export const StyledTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
    max-width: 11.25rem;
    overflow-wrap: break-word;
  }
`

//@ts-ignore
export const StyledActionTableCell = styled(StyledTableCell)`
  && {
    width: 9.375rem;
  }
`
export const SearchInput = styled(TextField)`
  & .MuiInput-input {
    background: no-repeat;
  }
  & .MuiInputBase-root {
    padding: 0em;
    bottom: 0.25em;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`

export const StyledDateBox = styled(Box)`
  border-radius: 5.125em;
`

export const StyledIconButton = styled(IconButton)`
  && {
    .MuiTypography-root {
      color: ${props => props.theme.colors.accent1};
      line-height: 1em;
      font-weight: bold;
      font-size: 0.75rem;
    }
  }
`
export const StyledLargeDeleteIcon = styled(Delete)`
  && {
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledImageBox = styled(Box)`
  margin-bottom: 1.2rem;
`

export const StyledModalContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const StyledQRImgWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`

export const StyledQRCodeContainer = styled(Box)`
  border-radius: 10px;
  border: 1px solid ${props => props.theme.colors.accent};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 3.2rem 0;
`

export const StyledQRWrapper = styled(Box)`
  width: 20;
`

export const StyleEventDetails = styled(Typography)`
  color: ${props => props.theme.colors.accent1};
  font-weight: 600 !important;
`
export const StyleDetails = styled(Typography)`
  color: ${props => props.theme.colors.accent1};
  display: flex;
  width: 12.5rem;
`

export const StyledEventNameDetails = styled(Typography)`
  color: ${props => props.theme.colors.accent1};
  display: -webkit-box;
  max-width: 12.5rem;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
`

export const StyledImage = styled.img`
  border-radius: 0.94rem;
  max-height: 411px;
`

export const StyledEventDetailsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const StyledDetailWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 7.5rem 12.5rem;
  justify-items: start;
`

export const StyledQRButton = styled(Button)`
  align-self: flex-end;
  background-color: ${props => props.theme.colors.primary} !important;
  color: ${props => props.theme.colors.bgPrimary} !important;
  font-weight: 600 !important;
`

export const StyledExpandLessIcon = styled(ExpandLess)`
  color: ${props => props.theme.colors.primary};
`

export const StyledExpandMoreIcon = styled(ExpandMore)`
  color: ${props => props.theme.colors.primary};
`